import { Injectable } from '@angular/core';
import {
  Compare,
  FormFieldConfig,
  FormTemplateSchema,
  TriggerGroupType
} from '../form-template-model';

@Injectable({
  providedIn: 'root'
})
export class FormTemplateGeneratorService {
  public supportingFields: { [key: string]: FormFieldConfig };
  public fieldsHiddenForPDFExportMap: { [key: string]: boolean };
  /** PDF export: Fabric signature rasterize promises registered by field generators. */
  private pdfRasterizePromises: Promise<void>[] = [];

  constructor() {
    // [kanata_IPL_and_RF_customQuestionnaire as FormTemplateSchema].forEach(questionnaire => {
    //   console.log(questionnaire);
    //   Object.values(questionnaire.templateGroups).forEach((group: FormTemplateGroup) => {
    //     console.log(group);
    //     Object.values(group.formFields).forEach((field, j) => {
    //       field.sort = j * 100;
    //       Object.values(field.typeConfig['valuesConfig'] || []).forEach(
    //         (valueConfig: ValueConfig, i) => {
    //           valueConfig.sort = i * 100;
    //         }
    //       );
    //     });
    //   });
    // });
    // console.log(JSON.stringify(kanata_IPL_and_RF_customQuestionnaire));
    // console.log(JSON.stringify(oliverQuestionnaire));
    // console.log(JSON.stringify(patientIntakeQuestion));
  }

  updateFieldsHiddenForPDFExportMap(key: string, hide: boolean) {
    this.fieldsHiddenForPDFExportMap = {
      ...this.fieldsHiddenForPDFExportMap,
      [key]: hide
    };
  }

  resetPdfRasterizePromises() {
    this.pdfRasterizePromises = [];
  }

  registerPdfRasterizePromise(promise: Promise<void>) {
    if (promise) {
      this.pdfRasterizePromises.push(promise);
    }
  }

  waitForPdfRasterizePromises(): Promise<void> {
    if (!this.pdfRasterizePromises.length) {
      return Promise.resolve();
    }
    return Promise.all(this.pdfRasterizePromises).then(() => undefined);
  }

  sortFormFieldsBySortKey(questionnaire: FormTemplateSchema) {
    if (!questionnaire || !questionnaire.templateGroups) return questionnaire; // Check if data or templateGroups is null/undefined

    Object.values(questionnaire.templateGroups).forEach(group => {
      if (!group.formFields) return; // Check if formFields is null/undefined

      // Convert formFields to an array, sort it, and then rebuild the object

      const a = Object.entries(group.formFields)
        .sort(([, a], [, b]) => a.sort - b.sort)
        .reduce((acc, [key, fieldSchema]) => {
          return {
            ...acc,
            [key]: fieldSchema
          };
        }, {});
    });

    return questionnaire;
  }

  evaluateTrigger(a: any, b: any, compareOperator: Compare) {
    a = this.convertToLowerCaseIfString(a);
    b = this.convertToLowerCaseIfString(b);
    switch (compareOperator) {
      case Compare.equals:
        return a === b;
      case Compare.lessThan:
        return a < b;
      case Compare.greaterThan:
        return a > b;
      case Compare.greaterThanOrEqual:
        return a >= b;
      case Compare.lessThanOrEqual:
        return a <= b;
      default:
        console.log('unknown comparison operator');
        return false;
    }
  }

  compareByTriggerGroupType(a: boolean, b: boolean, triggerGroupType: TriggerGroupType) {
    switch (triggerGroupType) {
      case TriggerGroupType.and:
        return a && b;
      case TriggerGroupType.or:
        return a || b;
      default:
        console.log('unknown trigger group operator');
        return false;
    }
  }

  convertToLowerCaseIfString(s: any) {
    if (typeof s === 'string') {
      return s.toLowerCase();
    }
    return s;
  }
}
